import { useMemo } from 'react';
import { TableColumnConfigDto } from '@asset-metrix/portal-gateway-client-js';
import { WidgetProps } from '@asset-metrix/portal-ui';

export type GroupOnlyVisualizationProps = {
  customizedColumns: TableColumnConfigDto[];
  enableGroupOnlyVisualization?: boolean;
  groupOnlyColumnId: string | null;
  onGroupOnlyColumnIdChange: (columnId: string | null) => void;
};

export const useGroupOnlyVisualization: (
  props: GroupOnlyVisualizationProps
) => WidgetProps['chipGroup'] = ({
  customizedColumns,
  enableGroupOnlyVisualization,
  groupOnlyColumnId,
  onGroupOnlyColumnIdChange,
}) => {
  const availableOptions = useMemo(() => {
    return customizedColumns
      .filter((column) => column.grouping != null)
      .map((column) => {
        return {
          value: column.id,
          label: column.label,
        };
      });
  }, [customizedColumns]);

  const selectedValue =
    groupOnlyColumnId != null &&
    availableOptions.some((option) => option.value === groupOnlyColumnId)
      ? groupOnlyColumnId
      : null;

  return enableGroupOnlyVisualization && availableOptions.length > 0
    ? {
        data: availableOptions,
        value: selectedValue,
        onChange: onGroupOnlyColumnIdChange,
      }
    : undefined;
};
